var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7939 10.853V9.79414C18.7939 6.8751 16.4188 4.5 13.4997 4.5C10.5807 4.5 8.20559 6.8751 8.20559 9.79414V10.853C7.03604 10.853 6.08789 11.801 6.08789 12.9707V20.3824C6.088 21.5519 7.03604 22.5 8.20559 22.5H18.7939C19.9634 22.5 20.9116 21.5518 20.9116 20.3823V12.9706C20.9115 11.801 19.9634 10.853 18.7939 10.853ZM10.3233 9.79414C10.3233 8.04251 11.7481 6.6177 13.4997 6.6177C15.2514 6.6177 16.6762 8.04251 16.6762 9.79414V10.853H10.3233V9.79414ZM14.5585 17.2059C14.5585 17.7906 14.0844 18.2647 13.4996 18.2647C12.9148 18.2647 12.4408 17.7906 12.4408 17.2059V15.0882C12.4408 14.5034 12.9148 14.0293 13.4996 14.0293C14.0844 14.0293 14.5585 14.5034 14.5585 15.0882V17.2059Z",
    fill: "#494545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockSvg);
export default __webpack_public_path__ + "static/media/unlock_svg.84686d904f1512c3b98f7f4586c9f5d4.svg";
export { ForwardRef as ReactComponent };